import React from 'react';
import { Container, Box } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import ReadyToSeeContent from './ReadyToSeeContent';

const ReadyToSeeMobile: React.FC = () => (
  <Container
    maxW="100%"
    px={0}
    d={{ base: 'flex', tablet: 'none' }}
    centerContent
    position="relative"
  >
    <Box h="1000px" justifyContent="center" maxW="lg">
      <StaticImage
        quality={100}
        placeholder="blurred"
        objectPosition="50% 20%"
        alt="ready to see"
        src="../../../assets/images/home_page_ready_to_see_mobile.png"
      />
    </Box>
    <Box maxW="lg" position="absolute" top="40px" px={500}>
      <ReadyToSeeContent />
    </Box>
  </Container>
);

export default ReadyToSeeMobile;
